import React, { Component } from 'react';
import * as MDICONS from '@material-ui/icons';
import { get } from 'lodash'
import { connect } from 'react-redux';
import { archiveFloorFromProject, openArchiveFloorFromProjectModal } from '../../../../store/actions/floorActions';
import ReactModal from 'react-modal';

class DeleteFloorModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showFloorDeleteModal: false,

        }
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = () => {
        this.setState({ showFloorDeleteModal: true, },
            () => this.props.openArchiveFloorFromProjectModal()
        );
    }

    handleCloseModal = () => {
        this.setState({ showFloorDeleteModal: false });
    }

    render() {
        const { userData, commonLabels, snagDetail, modalStyles, modalTitleStyle, modalInfoTextStyle, floor } = this.props;
        const { assetParts, assetPart } = commonLabels;
        const { fapiMessage, showFapiLoader, fapiIsDoneAndSent } = floor;

        const floorList = Object.values(snagDetail.floorsMap) ?? [];
        console.log(floorList);

        return (
            <React.Fragment>
                <div className="dynamicModalContainer">
                    <div className="dynamicModalSm">
                        <br></br>
                        <h5 style={modalTitleStyle}>Delete {assetParts}</h5>
                        <p style={modalInfoTextStyle}>When deleted, all the data associated with {assetPart} will become inaccessible</p>
                        {floorList.map((eachFloor, index) =>
                            <div key={eachFloor.floorid}>
                                <span>{eachFloor.name}</span>
                                <a style={{ fontSize: "10px", fontStyle: "italic" }} href="#!" role="button" className="pl-1" onClick={() => { this.handleOpenModal() }}>(Delete)</a>

                                <ReactModal
                                    style={modalStyles}
                                    isOpen={this.state.showFloorDeleteModal && !fapiIsDoneAndSent === true}
                                    onRequestClose={() => { this.handleCloseModal() }}
                                    contentLabel="Delete Project"
                                    ariaHideApp={false}
                                >
                                    <button className="close" onClick={() => { this.handleCloseModal() }}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <div className="dynamicModalContainer">
                                        <div className="dynamicModalSm">
                                            <React.Fragment>
                                                <p style={modalTitleStyle}>Confirm delete this {assetPart}?</p>
                                                <p style={modalTitleStyle}>Warning:</p>
                                                <p style={modalInfoTextStyle}>Please you must note that this will permenantly delete this {assetParts}.</p>
                                                <br />

                                                {!showFapiLoader ? <div className="btn btn-danger btn-sm" style={{ float: "right", borderRadius: '7px' }} onClick={() => this.props.archiveFloorFromProject(userData, snagDetail, eachFloor)} >Confirm</div> : <button className="btn btn-danger btn-sm" style={{ float: "right", borderRadius: '7px' }} type="button" disabled>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    &nbsp; Deleting the {assetPart}...
                                                </button>}
                                            </React.Fragment>
                                        </div>
                                    </div>
                                </ReactModal>
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userData: state.firebase.profile,
        alu: state.alu,
        floor: state.floor,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        commonLabels: state.commons,
        // styles
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openArchiveFloorFromProjectModal: () => dispatch(openArchiveFloorFromProjectModal()),
        archiveFloorFromProject: (userModelJson, projectModelJson, floorMapJson) => dispatch(archiveFloorFromProject(userModelJson, projectModelJson, floorMapJson)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(DeleteFloorModal);